import { useState } from "react";
import { Sparkles, Loader2, Check, X } from "lucide-react";
import { toast } from "sonner";

export const AiSuggest = ({ label = "Improve with AI", run, onAccept, disabled, testId }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const go = async () => {
    setBusy(true);
    setText("");
    try {
      await run(setText);
    } catch (e) {
      toast.error(e.message);
      setText("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <button type="button" onClick={go} disabled={busy || disabled} data-testid={`${testId}-btn`}
        className="inline-flex items-center gap-1.5 rounded-full border border-thread/30 bg-thread-light px-3 py-1 text-xs font-semibold text-thread transition-colors hover:bg-thread hover:text-white disabled:opacity-50 disabled:hover:bg-thread-light disabled:hover:text-thread">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />}
        {busy ? "Writing…" : label}
      </button>
      {(text || busy) && (
        <div data-testid={`${testId}-suggestion`} className="mt-3 rounded-lg border border-thread/25 bg-white p-4 text-sm leading-relaxed text-ink shadow-sm">
          <p className="eyebrow mb-2 !text-thread">AI suggestion</p>
          <p className={`whitespace-pre-wrap ${busy ? "caret" : ""}`}>{text}</p>
          {!busy && text && (
            <div className="mt-3 flex gap-2">
              <button type="button" className="btn-thread !px-3 !py-1.5 !text-xs" data-testid={`${testId}-accept`}
                onClick={() => { onAccept(text.trim()); setText(""); toast.success("AI suggestion applied"); }}>
                <Check className="h-3.5 w-3.5" /> Use this
              </button>
              <button type="button" className="btn-ink !px-3 !py-1.5 !text-xs" data-testid={`${testId}-discard`} onClick={() => setText("")}>
                <X className="h-3.5 w-3.5" /> Discard
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
